import { format, parseISO } from "date-fns";

// Returns format "2025-03-19"
export const formatDateYYYYMMDD = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "yyyy-MM-dd");
};

// Returns format "19 Mar 2025"
export const formatDateText = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "d MMM yyyy");
};

// Returns format "19 Mar"
export const formatDateTextShort = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "d MMM");
};

// Returns format "March 2025"
export const formatDateMonthYear = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "LLLL yyyy");
};

// Returns format "Mar 2025"
export const formatDateMonthYearShort = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "MMM yyyy");
};

// Returns a date object with the time set to midnight UTC
export const toUTCDateOnly = (date: Date) => {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
};

// Returns format "Friday, March 19, 18:50"
export const formatDateTextWeekdayTime = (date: Date | string): string => {
  const parsed = typeof date === "string" ? parseISO(date) : date;
  return format(parsed, "EEEE, MMMM d, HH:mm");
};
